import { RoomType, SpaceReadModel } from '@client/api';

export const useRoomsCount = (space: SpaceReadModel | undefined | null): number | undefined => {
  if (space == null) return;

  const { roomCount: roomCountObj } = space;

  if (roomCountObj == null) return;

  const roomsCount = Object.keys(roomCountObj)
    .filter((roomType) => roomType as RoomType !== 'Bathroom' && roomType as RoomType !== 'Toilet')
    .reduce((acc, roomType) => acc + (roomCountObj[roomType] ?? 0), 0);

  return roomsCount;
}
